import { Divider, BreadcrumbLink, VStack, Box, Container } from '@chakra-ui/react';
import { ChatOverlayViewProps } from './chatOverlayProps';
import React from 'react';
import { ReportingShellViewBaseConfig } from '../../../base';
import { ChatDetailContainerProps } from '../detail';
import { createUseResizableHook } from '../../../util/use-resizable';
import { ChatCreateContainerProps } from '../create';
import { ChatLayoutContainerProps } from '../layout';

export function createChatOverlayView(
    config: ReportingShellViewBaseConfig & {
        Container: {
            Detail: React.FC<ChatDetailContainerProps>;
            Create: React.FC<ChatCreateContainerProps>;
            Layout: React.FC<ChatLayoutContainerProps>;
        };
    }
): React.FC<ChatOverlayViewProps> {
    const {
        UI: {
            Application: { Anchor, Link, createErrorBoundary },
        },
        Container: {
            Detail: DetailContainer,
            Create: CreateContainer,
            Layout: LayoutContainer,
        },
    } = config;

    const useResizable = createUseResizableHook();

    return (props) => {
        // if (!props.overlay.isOpen) {
        //     return null;
        // }

        const resizableProps = useResizable({
            width: props.width,
            minWidth: props.minWidth,
            maxWidth: props.maxWidth,
            initialWidth: props.initialWidth,
            direction: 'right',
        });

        return (
            <Box
                w={resizableProps.layout.width}
                h="full"
                position="relative"
                {...(props.overlay.isOpen ? {} : { w: 0, overflow: 'hidden' })}
            >
                {/* Resize handle with expanded hit area */}
                <Box
                    aria-pressed={resizableProps.resize.isResizing}
                    {...resizableProps.resize.handle}
                    position="absolute"
                    left="-6px"
                    top={0}
                    bottom={0}
                    flexShrink={0}
                    h="full"
                    cursor="col-resize"
                    w={3}
                    zIndex="docked"
                    _before={{
                        content: '""',
                        position: 'absolute',
                        left: '5px',
                        top: 0,
                        bottom: 0,
                        width: '2px',
                        bg: 'whiteAlpha.200',
                        pointerEvents: 'none',
                    }}
                    _hover={{
                        _before: {
                            bg: 'whiteAlpha.300',
                        },
                    }}
                    _pressed={{
                        _before: {
                            bg: 'whiteAlpha.400',
                        },
                    }}
                />
                <LayoutContainer {...props.layout}>
                    {props.page.id === 'detail' && (
                        <DetailContainer {...props.page.props} />
                    )}
                    {props.page.id === 'create' && (
                        <CreateContainer {...props.page.props} />
                    )}
                </LayoutContainer>
            </Box>
        );
    };
}
